import { render, staticRenderFns } from "./NewParts.vue?vue&type=template&id=00f2d462&scoped=true"
import script from "./NewParts.vue?vue&type=script&lang=js"
export * from "./NewParts.vue?vue&type=script&lang=js"
import style0 from "./NewParts.vue?vue&type=style&index=0&id=00f2d462&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f2d462",
  null
  
)

export default component.exports